import WhatsappIconSVG from './WhatsappIcon';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getFooterData } from "../redux/FooterSlice";
import { useParams} from 'react-router-dom';
import { Link } from 'react-router-dom';
import { a, animateScroll as scroll } from "react-scroll";

function Footer(props) {
  // Fetching State
  const dispatch = useDispatch();
  const { footer } = useSelector((state) => state.FooterData);
  const { status } = useSelector((state) => state.FooterData);
  const params = useParams();
  useEffect(() => {
      ////Passing page ID reference
      if (status !== "success") {
        dispatch(getFooterData({ params }));
      }
      }, [dispatch]);
  
      if (status === "loading") {
        return (
          <div></div>
        );
      }
  
      if (status === "success") {
        // console.log(footer);
    }
  return(
    <div className="Footer bottomSections">
      {status === 'success' && 
      <>
      <div className="footer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="row justify-content-start">
                <div className="col-xl-2 col-md-3 Footer_Links">
                  <ul>
                    {footer.acf.footer_menu?.map((el,i)=>{
                        return <li key={i}><Link to={el.link.url}>{el.link.title}</Link></li>
                    })}
                  </ul>
                </div>
                <div className="col-xl-3 col-md-4 d-block d-md-none">
                  <div className="footerSocialIcons text-center mt-4 mb-4">
                    {footer.acf.social_icons ? footer.acf.social_icons.map((el,i)=>{
                        return <a key={i} target="_blank" href={el.link} dangerouslySetInnerHTML={{__html: el.icon}}></a>
                    }) : null}
                  </div>
                  {/* <div className="FooterNewsletter">
                    <h3>{footer.acf.newsletter_heading}</h3>
                    <form>
                      <input type="email"></input>
                      <input type="submit" value="Send"></input>
                    </form>
                  </div> */}
                </div>
                <div className="col-xl-3 col-md-5 footerAddress">
                  <h4>{footer.acf.footer_contact_heading}</h4>
                  <p><a href={footer.acf.address_link} target="_blank">{footer.acf.address}</a></p>
                  <p><a href={footer.acf.phone.url}>{footer.acf.phone.title}</a></p>
                  <p><a href={footer.acf.email.url}>{footer.acf.email.title}</a></p>
                </div>
              </div>
              <div className="row justify-content-between mt-5 mt-md-4">
                <div className="col-xl-4 col-md-4 footerSocialIcons d-none d-md-block">
                  {footer.acf.social_icons ? footer.acf.social_icons.map((el,i)=>{
                    return <a key={i} target="_blank" href={el.link} dangerouslySetInnerHTML={{__html: el.icon}}></a>
                  }) : null}
                </div>
                <div className="col-xl-6 col-md-8 text-center text-md-end">
                  <span className="copyright">{footer.acf.copyright}</span>
                  <span className="copyright d-block"><a href="https://arenacapital.com/website-design-development/" target="_blank">Website</a> <span>by</span> <a target="_blank" href="https://arenacapital.com/">ARENA</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WhatsappIconSVG waNumber={footer.acf.whatsapp_number}/>
      </>}
      <a className="goTop" activeClass="active" href="#BringItTop" spy={true} smooth={true} offset={-200} duration={100}></a>
    </div>
  );
}
export default Footer;